import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image26 from "../../../../assets/images/Blog48/image26.png";
import image27 from "../../../../assets/images/Blog48/image27.png";
import image37 from "../../../../assets/images/Blog48/image37.png";
import image29 from "../../../../assets/images/Blog48/image29.png";
import image14 from "../../../../assets/images/Blog48/image14.png";
import image16 from "../../../../assets/images/Blog48/image16.png";
import image17 from "../../../../assets/images/Blog48/image17.png";
import image50 from "../../../../assets/images/Blog48/image50.png";
import image4 from "../../../../assets/images/Blog48/image4.png";
import image31 from "../../../../assets/images/Blog48/image31.png";
import image32 from "../../../../assets/images/Blog48/image32.png";
import image33 from "../../../../assets/images/Blog48/image33.png";
import image56 from "../../../../assets/images/Blog48/image56.png";
import image41 from "../../../../assets/images/Blog48/image41.png";
import image21 from "../../../../assets/images/Blog48/image21.png";
import image78 from "../../../../assets/images/Blog48/image78.png";
import image89 from "../../../../assets/images/Blog48/image89.png";
import image88 from "../../../../assets/images/Blog48/image88.png";

const Blog48 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – December 22nd, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedBoldText ">Seasonality Reappears, Disinflation Comforts, and Liquidity Does the Heavy Lifting</p>
        <p>
          Markets finally found their footing last week after a hesitant start driven by delayed US data releases and a crowded central-bank calendar. Once those hurdles were cleared, price action
          stabilised and flows reasserted themselves, allowing equities to lean back into year-end seasonality. The rally did not come from fresh macro optimism, but from the removal of uncertainty
          and the steady bid from positioning and liquidity.
        </p>
        <p>
          This was not a breakout week — but it was an important one. Inflation data moved in the right direction, labour markets cooled without collapsing, and risk assets were given room to breathe.
          At the same time, sentiment indicators and flow concentration are becoming harder to ignore, suggesting that while the tape remains supportive, the margin for error is shrinking as we look
          toward 2026.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: Flows Reassert as Seasonality Finds Its Timing</p>
              <p>
                Equities spent the early part of the week chopping sideways as markets worked through US catch-up data and multiple central-bank decisions. Once those passed, price action improved
                meaningfully. Options expiry removed a layer of negative hedging, and market-makers appeared to rebalance risk into year-end rather than press shorts.
              </p>
              <p>Seasonality is now firmly back in play, with equities entering historically strong periods for performance.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image26}
                    alt="hot period ahead for equities"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image26)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                That said, the PDF also highlights that not all Santa rallies are smooth. Late-year strength has, in the past, given way to sharper pullbacks when positioning becomes crowded or
                liquidity thins too quickly.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image27}
                    alt="beware if santa drops the presents"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image27)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Flows remain the dominant driver. Bank of America data shows one of the largest weekly inflows into equities on record, led overwhelmingly by US stocks and passive vehicles.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image37}
                    alt="ETF inflows at record"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image37)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Importantly, this is occurring alongside record balances still parked in money-market funds, suggesting redeployment of cash rather than outright speculation. Hedge funds, however,
                remain persistent sellers on downside moves, reinforcing the idea that this is a flow-driven grind rather than a conviction-led surge.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image29}
                    alt="hedgies selling whatever the weather"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image29)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Disinflation Helps, Fiscal Reality Lingers</p>

              <p>
                Inflation data continues to move in a favourable direction, particularly when viewed through a smoothed lens. The six-month trend in headline US CPI shows clear disinflationary
                momentum.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="headline US CPI 6m win"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                A major driver remains shelter inflation. The PDF repeatedly stresses that the shelter’s statistical lag — combined with its outsized weight in CPI — exaggerated inflation on the way
                up and is now accelerating the decline.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt="miran and i looking for shelter"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt="shelter hits cpi print"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This supports the near-term easing narrative and helps explain why markets are increasingly comfortable with the idea of lower policy rates. However, the rate picture is complicated by
                fiscal dynamics. Planned 2026 fiscal programmes continue to pressure the long end of the curve, keeping upward bias in yields even as inflation cools.
              </p>
              <p>Bond volatility remains unusually subdued, with the MOVE index back near 2021 lows.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="MOVE at 2021 lows"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>
                The analyst framing is clear: reserve-management operations and quiet balance-sheet support are becoming more important than policy rhetoric. Disinflation helps risk assets for now —
                but fiscal dominance will shape the next phase.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown: Support Holding, Leadership Crowding</p>
              <p>
                From a technical standpoint, broader indices remain intact, with long-term trends holding and recent consolidation occurring near highs rather than breaking lower. Price action
                continues to reflect resilience, but it is increasingly uniform across indices, suggesting stability without strong internal momentum.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt="all the same index"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt="mixed SPX around ATH pullbacks"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Momentum has moderated meaningfully. The market appears to be transitioning from an explosive advance into a slower, grind-higher phase — still upwardly biased, but far more sensitive
                to disappointment as marginal buyers become selective.
              </p>
              <p>
                Leadership dynamics remain critical. Options data shows renewed call buying in tech-heavy indices, signalling continued appetite for upside exposure. At the same time, downside
                protection in the S&P has become elevated enough to act as a short-term contrarian tailwind, suggesting hedging demand may be peaking rather than accelerating.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image32}
                    alt="nasdaq100 call buying"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image32)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="SPX put buying overdone"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Rotation beneath the surface continues. Broader participation is helping stabilise indices, but leadership concentration and crowding risks remain evident beneath the headline
                strength.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image56}
                    alt="bubble conditions "
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image56)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                Sentiment, however, is no longer benign. Bank of America’s risk indicators have pushed into elevated territory, a condition historically associated with choppier forward returns rather
                than clean upside continuation.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt=" new BoA risk model on alert for sell"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>This is a market still supported by structure — but increasingly unforgiving of crowded positioning and sentiment excess.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Data Catch-Up, Central Banks, and Flow Relief</p>
              <p>
                Markets began the week cautiously as investors worked through delayed US data and a heavy slate of central-bank decisions, but stabilised into Friday as inflation prints softened, tech
                fears eased, and year-end flows reasserted themselves.
              </p>
              <p className="highlightedText">Key Highlights:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span>
                    <br></br>US inflation data continued to move in the right direction, with shelter components finally reflecting real-world rental declines. The lagged nature of shelter inflation
                    and its heavy CPI weighting — dragged headline prints lower, reinforcing the disinflation narrative and easing pressure on risk assets.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image14}
                        alt="headline US cpi 6m win"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image14)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China:</span>
                    <br></br>Chinese data remained soft, with retail sales and domestic demand underscoring the fragility of the consumer. Fixed asset investment continues to disappoint, and while
                    policy support is being delivered, it remains targeted and slow to gain traction.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image21}
                        alt="china data disaster"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image21)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings:</span>
                    <br></br>Tech sentiment stabilised following Micron’s update, which helped soothe concerns around near-term demand and capital-expenditure visibility. While earnings season is
                    thinning into year-end, leadership reassurance proved important in restoring confidence.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities: </span>
                    <br></br> Precious metals continued to push higher, with gold, silver, and platinum extending gains as liquidity expectations and debasement narratives stayed firmly in place.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image78}
                      alt="gold follows the money"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image78)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto:</span>
                    <br></br>Volatility earlier in the week looked increasingly like a positioning shakeout. Flows stabilised into the end of the week, with signs that larger participants were
                    accumulating rather than distributing.
                  </p>
                </li>
                <div className="imageWrapperCont">
                  <div className="relatedImg">
                    <img
                      src={image89}
                      alt="the buyers are back in town for Bitcoin"
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image89)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </div>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Oil:</span>
                    <br></br>Energy prices remained capped, with sentiment still leaning bearish. Positioning looks vulnerable; however, should supply dynamics tighten or broader reflation narratives
                    regain momentum.
                  </p>
                  <div className="imageWrapperCont">
                    <div className="relatedImg">
                      <img
                        src={image88}
                        alt="oil may catch up with energy buying soo"
                      />
                      <div
                        className="zoomBtn"
                        onClick={() => handleLargeImg(image88)}
                      >
                        <button>
                          <img
                            src={zoomImg}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: Holiday Liquidity, GDP Focus, and Inflation Follow-Through</p>
              <p>
                This is a shortened holiday week with thinning liquidity, increasing the risk that even routine data surprises produce outsized market reactions. With major central-bank decisions
                behind us, focus shifts to <span className="highlightedText">US growth confirmation, inflation follow-through, and Japan inflation signals,</span> all against a quieter but more
                fragile year-end tape.
              </p>
              <p className="highlightedText">Monday, Dec 22</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">CNY: </span> One-Year & Five-Year Loan Prime Rate (LPR)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">GBP: </span> Q3 GDP (Final), Current Account
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Core PCE (MoM, YoY)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> USD:</span> Personal Income & Personal Spending
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Dallas Fed PCE
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, Dec 23</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> Core CPI (YoY)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> GDP (Q3), Core PCE Prices (Q3), Corporate Profits
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Atlanta Fed GDPNow (Q4 – first estimate)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Consumer Confidence
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                Wednesday, Dec 24 <span style={{fontStyle: "italic"}}>(Markets Close Early)</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Initial & Continuing Jobless Claims
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Crude Oil Inventories
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Mortgage Applications
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                Thursday, Dec 25 <span style={{fontStyle: "italic"}}>(Christmas Day – Markets Closed)</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> Tokyo CPI (Headline, Core)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> CPI ex-Food & Energy
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> Unemployment Rate
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> Industrial Production (MoM)
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">JPY:</span> Retail Sales (YoY)
                  </p>
                </li>
              </ul>

              <p className="highlightedText">
                Friday, Dec 26 <span style={{fontStyle: "italic"}}>(Boxing Day – US Markets Open)</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">USD:</span> Thin liquidity — focus on flows and positioning
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Supportive Tape — But Crowding Is the Risk</p>
              <p>
                Markets are benefiting from a rare alignment of disinflation relief, seasonal tailwinds, and powerful passive flows. That combination is supporting risk assets into year-end — but it
                is also compressing forward returns and raising sensitivity to positioning extremes.
              </p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span>
                    <br></br>The structure remains constructive, with indices holding key trends and flows that provide support. However, sentiment is stretched, and upside is increasingly dependent
                    on rotation rather than broad multiple expansion.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold & Silver:</span> <br></br>The structural case remains intact as liquidity expectations and debasement themes persist. Pullbacks appear more
                    corrective than terminal, although near-term consolidation would be healthy following recent gains.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Crypto: </span> <br></br>Stabilisation is encouraging following recent volatility. Any renewed upside remains tied to liquidity conditions and
                    broader risk appetite rather than idiosyncratic catalysts.
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Macro: </span> <br></br> Disinflation is easing pressure on policy, but fiscal dynamics and bond-market behaviour will increasingly dictate
                    conditions in 2026. Real rates — not just rate cuts — remain the key variable.
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Flows are still carrying the market — but crowded trades unwind quietly before they unwind violently. Participate, but stay nimble.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image41}
                    alt="new BoA risk model on alert for sell"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image41)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image50}
                    alt="MOVE at 2021 lows"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image50)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image89}
                    alt="the buyers are back in town for Bitcoin"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image89)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/11rqOL7Q9GlPZa_U0tZbhARHlHc_-2sGaNAL6S-UAZlk/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
        <hr className="divisionLine" />
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog48;
